var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{staticClass:"flex-shrink rounded-full",attrs:{"src":_vm.src,"alt":_vm.src,"width":_vm.size,"height":_vm.size}})])}
var staticRenderFns = []

export { render, staticRenderFns }